
import Vue, { PropType } from 'vue';
import countries from 'highered-utils/data/countries.json';
import { AddressFormData, CountryItem } from '../types';

export default Vue.extend({
    name: 'AddressForm',
    props: {
        value: {
            type: Object as PropType<AddressFormData>,
            required: true,
        },
        noShipping: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        excludeShipping(): boolean {
            return this.noShipping || !this.value.shipping;
        },
    },
    data() {
        return {
            countries: countries as CountryItem[],

            shippingSameAsAddress: true,
            shippingAddress: null as Omit<AddressFormData, 'shipping'> | null,
            shippingName: '',
            shippingPhone: '',
        };
    },
    methods: {
        handleInput(data: Partial<AddressFormData>) {
            const newValue = {
                ...this.value,
                ...data,
            };
            if (this.shippingSameAsAddress) {
                const { shipping, ...address } = newValue;
                newValue.shipping = {
                    name: shipping ? shipping.name : '',
                    phone: shipping ? shipping.phone : '',
                    address: {
                        ...address,
                    },
                };
            }

            this.$emit('input', newValue);
        },
        handleInputShipping(field: 'name' | 'phone', value: string) {
            this.$emit('input', {
                ...this.value,
                shipping: {
                    ...this.value.shipping,
                    [field]: value,
                },
            });
        },
        handleInputShippingAddress(data: Omit<AddressFormData, 'shipping'>) {
            this.$emit('input', {
                ...this.value,
                shipping: {
                    ...this.value.shipping,
                    address: data,
                },
            });
        },
        handleShippingSameAsAddress(value: boolean) {
            this.shippingSameAsAddress = value;
            if (value) this.$emit('reset-shipping');
        },
    },
    mounted() {
        if (typeof this.value.shipping !== 'undefined') {
            this.shippingAddress = this.value.shipping.address;

            const shippingSameAsAddress =
                this.shippingAddress.country === this.value.country &&
                this.shippingAddress.state === this.value.state &&
                this.shippingAddress.postalCode === this.value.postalCode &&
                this.shippingAddress.city === this.value.city &&
                this.shippingAddress.line1 === this.value.line1 &&
                this.shippingAddress.line2 === this.value.line2;
            this.handleShippingSameAsAddress(shippingSameAsAddress);
        }
    },
});
